import React from 'react';
import { makeStyles, TextField, FormControl } from '@material-ui/core';
import { t } from 'src/shared/literals';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '220px',
    margin: theme.spacing(1)
  }
}));

const FormDateTime = ({ field, handleChangeField }) => {
  const classes = useStyles();

  const { name, value, errorMessage, readonly } = field;

  const handleChange = (e) => {
    e.target.value = moment(e.target.value).format('yyyy-MM-DDTHH:mm');
    handleChangeField(e);
  };

  return (
    <FormControl className={classes.formControl} key={name}>
      <TextField
        error={Boolean(errorMessage)}
        helperText={t(errorMessage)}
        label={t(name.toString())}
        margin="normal"
        name={name}
        onBlur={() => {}}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true
        }}
        InputProps={{
          readOnly: readonly
        }}
        type="datetime-local"
        value={value ? moment(value).format('yyyy-MM-DDTHH:mm') : ''}
        variant="outlined"
        className={classes.textField}
      />
    </FormControl>
  );
};

export default FormDateTime;
